export const formatDateToDDMMYYYY = (isoDateString: string): string => {
  const date = new Date(isoDateString);
  if (Number.isNaN(date.getTime())) return ""; // Use Number.isNaN here

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export const formatToLocalDateTime = (
  isoString: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  const date = new Date(isoString);

  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  return date.toLocaleString(undefined, { ...defaultOptions, ...options });
};

export const formatToLocalTime = (
  isoString: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  const date = new Date(isoString);

  const defaultOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Change to false for 24-hour format
  };

  return date.toLocaleTimeString(undefined, { ...defaultOptions, ...options });
};

export const formatToLocalTimeDashboard = (
  isoString: string,
  options: Intl.DateTimeFormatOptions = {}
): string => {
  const date = new Date(isoString);

  const defaultOptions: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true, // Change to false for 24-hour format
  };

  return date.toLocaleTimeString(undefined, { ...defaultOptions, ...options });
};
